import React from 'react';
import StatusItem from '../StatusBar/StatusItem/StatusItem';
import { EyeNew } from '../../assets/icons';
import { useChannel } from '../../contexts/Channel';
import { clsm } from '../../utils';
import useViewerCount from '../../hooks/useViewerCount';

export default function ViewerCount() {
  const { channelData } = useChannel();
  const { formattedViewerCount } = useViewerCount();
  const { isLive } = channelData;
  return (
    <>
      {isLive && (
        <div className="bg-gray-400/20  rounded-full">
          <StatusItem
            tooltipText={'Concurrent Viewers'}
            dataTestId="concurrent-viewers"
            icon={<EyeNew />}
            isLive={isLive}
            itemLabel="Stream concurrent viewers count"
            value={formattedViewerCount === '0' ? '--' : formattedViewerCount}
            className={clsm(['max-w-none', 'w-[68px]', 'justify-center'])}
          />
        </div>
      )}
    </>
  );
}
